export const opinions = [
	{
		name: 'Jane Doe',
		date: '14. Januar 2017',
		title: 'Sehr lecker',
		content: 'Sehr lecker und frisch',
		rating: 3,
	},
	{
		name: 'John Doe',
		date: '24. Juli 2017',
		title: 'Schmeckt jedes Mal',
		content: 'Der Fisch ist wirklich knusprig, was ich sonst nicht aus Kantinen kenne.',
		rating: 4,
	},
	{
		name: 'Jane Doe',
		date: '14. Januar 2017',
		title: 'Sehr lecker',
		content: 'Sehr lecker und frisch',
		rating: 3,
	},
	{
		name: 'John Doe',
		date: '24. Juli 2017',
		title: 'Schmeckt jedes Mal',
		content: 'Der Fisch ist wirklich knusprig, was ich sonst nicht aus Kantinen kenne.',
		rating: 4,
	},
	{
		name: 'Jane Doe',
		date: '14. Januar 2017',
		title: 'Sehr lecker',
		content: 'Sehr lecker und frisch',
		rating: 3,
	},
	{
		name: 'John Doe',
		date: '24. Juli 2017',
		title: 'Schmeckt jedes Mal',
		content: 'Der Fisch ist wirklich knusprig, was ich sonst nicht aus Kantinen kenne.',
		rating: 4,
	},
];


// WEBPACK FOOTER //
// ./src/dishes/defaults/opinions.js